import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiService } from '../../core/_services/api/api.service';
import { BaseApi } from '../../shared/_models/base-api';

@Injectable({
  providedIn: 'root',
})
export class CompanyService extends BaseApi {
  constructor(private _apiService: ApiService) {
    super();
  }

  public getCompanyDataById(id: number|string): Observable<any[]> {
    return this._apiService
      .get(`Company/${id}`)
      .pipe(map((response: any) => response));
  }

  updateGenInfoData(data: any): Observable<any> {
    return this._apiService.put(`Company/`, data);
  }

  saveContactInfoData(data: any): Observable<any> {
    return this._apiService.post(`Contact/Multiple`, data);
  }

  saveAddressInfoData(data: any): Observable<any> {
    return this._apiService.post(`CompanyLocation/Multiple`, data);
  }

  saveGeneralInfoData(data: any): Observable<any> {
    return this._apiService.post(`Company/`, data);
  }

  saveUpdateGeneralInfoData(data: any): Observable<any> {
    return this._apiService.post(`Company/Multiple`, data);
  }

  public getCompanyLoactionsById(id: any): Observable<any[]> {
    return this._apiService
      .get(`CompanyLocation/GetCompanyLocationByCO_ID${id}`)
      .pipe(map((response: any) => response));
  }

  public getCompanyContactsById(id: any): Observable<any[]> {
    return this._apiService
      .get(`Contact/GetCompanyContactsByCO_ID${id}`)
      .pipe(map((response: any) => response));
  }

  public getDiversityTypeIdAndEthinicityId(id: any): Observable<any[]> {
    return this._apiService
      .get(`Company/GetDiversityTypeIdAndEthinicityId?co_id=${id}`)
      .pipe(map((response: any) => response));
  }

  saveEthnicityDiversityTypes(data: any): Observable<any> {
    return this._apiService.post(`Company/AddCoDiversityTypes`, data);
  }
  getSystemParameterValues(): Observable<any> {
    return this._apiService
      .get(`Company/GetSystemParameterValues`)
      .pipe(map((response: any) => response));
  }

  getGoogleMapApiKey(): Observable<any> {
    return this._apiService
      .get(`Secrets`)
      .pipe(map((response: any) => response));
  }

  getSelectEthnicityType(): Observable<any> {
    return this._apiService
      .get(`Company/selectEthnicityType`)
      .pipe(map((response: any) => response));
  }

  public getCompanyContactsAndUsersById(co_id: any): Observable<any[]> {
    return this._apiService
      .get(`Contact/GetContactAndUserDetailsByCompany?co_id=${co_id}`)
      .pipe(map((response: any) => response));
  }

  getAllCompanies(): Observable<any> {
    return this._apiService
      .get(`Company`)
      .pipe(map((response: any) => response));
  }
}
